import React, { useState } from "react";
import { SearchResult } from "../Types/SearchResult.interface";
import BookCard from "./BookCard";
import { Link } from "react-router-dom";

interface QuickSearchResultsProps {
    results: SearchResult | undefined;
}

const QuickSearchResults: React.FC<QuickSearchResultsProps> = ({ results }) => {
    const [selectedBookId, setSelectedBookId] = useState<string | null>(null);

    const handleClick = (bookId: string | undefined) => {
        if(bookId){
            setSelectedBookId(bookId);
        }
    };

    if (!results) {
        return null;
    }

    if (selectedBookId) {
        return <Link to={`/book/${selectedBookId}`} />;
    }

    if (results.numFound === 0) {
        return (
            <div>
                <h2>Aucun résultat..</h2>
            </div>
        );
    }

    return (
        <div className={""}>
            <h2>{`${results.numFound} résultats trouvés`}</h2>
            <div className={"wrap"}>
                {results.docs.map((result, index) => (
                    <div className={"card"} key={index} onClick={() => handleClick(result.key)}>
                        <Link className={""} to={result.key ? result.key : "/"}>
                            <BookCard book={result}/>
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default QuickSearchResults;
